<main>
    <router-outlet></router-outlet>

    <app-modal [isVisible]="isShowVersionModal" (onClose)="isShowVersionModal = false">
        <div modal-title class="modal-title">
            <h3>{{ 'UPDATE-MODAL.TITLE' | translate }}</h3>
        </div>

        <div modal-body>
            <div class="version-wrapper">
                <div class="version-description">
                    <p>
                        <span>{{ appVersion.actual }}</span>
                        {{ 'UPDATE-MODAL.DESCRIPTION' | translate }}
                        <span>{{ appVersion.new }}</span></p>
                </div>
                <div class="version-action">
                    <button class="btn" (click)="updateApp()">Update</button>
                    <button class="btn" (click)="isShowVersionModal = false">Close</button>
                </div>
            </div>
        </div>
    </app-modal>
</main>
